import { formatDate } from '../utils/formatDate';
import { controlClose, findNextControlTrigger } from './c-common';

export default function () {
  let dateStart = null;
  let dateEnd = null;
  let isDatepickerBW = false;
  const userLocale = document.documentElement.lang || navigator.language || 'en-US';

  function checkin(datepicker, event) {
    const elementDate = datepicker.querySelector('.js-datepicker-checkin');
    const { target } = event;
    const { date } = target.dataset;

    elementDate.dataset.checkin = date;
    elementDate.textContent = formatDate(date, 'MMM d', userLocale);
  }

  function checkout(datepicker, event) {
    const elementDate = datepicker.querySelector('.js-datepicker-checkout');
    const { target } = event;
    const { date } = target.dataset;
    const checkoutDay = formatDate(date, 'MMM d', userLocale);
    const checkoutYear = formatDate(date, 'Y', userLocale);

    elementDate.dataset.checkout = date;
    elementDate.textContent = `${checkoutDay}, ${checkoutYear}`;
  }

  function rangeUpdate(days) {
    days.forEach((day) => {
      const { date } = day.dataset;
      const d = new Date(date);

      day.classList.remove('selected', 'range');

      if (dateStart && d.getTime() === dateStart.getTime()) {
        day.classList.add('selected');
      }

      if (dateEnd && d.getTime() === dateEnd.getTime()) {
        day.classList.add('selected');
      }

      if (dateStart && dateEnd && d >= dateStart && d <= dateEnd) {
        day.classList.add('range');
      }
    });
  }

  function getSaveButton(datepicker) {
    return datepicker?.querySelector('.js-datepicker-save') ?? null;
  }

  function saveButtonShow(datepicker, event) {
    const button = getSaveButton(datepicker);
    if (!button) {
      return;
    }

    button.classList.add('show');

    const focusButton = () => {
      button.focus();
    };

    if (event?.type === 'keydown' && event.key === 'Enter') {
      window.addEventListener(
        'keyup',
        ({ key }) => {
          if (key === 'Enter') {
            focusButton();
          }
        },
        { once: true },
      );
      return;
    }

    focusButton();
  }

  function saveButtonHide(datepicker) {
    const button = getSaveButton(datepicker);
    button?.classList.remove('show');
  }

  function focusDay(datepicker, date) {
    if (!datepicker || !date) {
      return;
    }

    const selector = `.js-datepicker-day[data-date="${date}"]`;
    const dayElement = datepicker.querySelector(selector);
    if (dayElement) {
      dayElement.focus();
    }
  }

  function dayClickCallback(datepicker, event) {
    const { target } = event;
    const { date } = target.dataset;
    const dateClicked = new Date(date);

    if (!dateStart || (dateStart && dateEnd)) {
      dateStart = dateClicked;
      dateEnd = null;
      checkin(datepicker, event);
      saveButtonHide(datepicker);
    } else {
      const canSelectCheckout = isDatepickerBW ? dateClicked > dateStart : dateClicked >= dateStart;

      if (canSelectCheckout) {
        dateEnd = dateClicked;
        checkout(datepicker, event);
        saveButtonShow(datepicker, event);
        return;
      }

      dateStart = dateClicked;
      checkin(datepicker, event);
      saveButtonHide(datepicker);
    }
  }

  window.document.addEventListener('DOMContentLoaded', () => {
    const datepicker = window.document.querySelector('.js-datepicker');
    if (!datepicker) return;

    const datepickerBW = datepicker.querySelector('.js-datepicker-bw') ?? null;
    isDatepickerBW = Boolean(datepickerBW);

    let days = datepicker.querySelectorAll('.js-datepicker-day');

    if (datepickerBW) {
      days = datepicker.querySelectorAll('.js-datepicker-day:not(.past)');
    }

    days.forEach((day) => {
      day.addEventListener('click', (event) => {
        dayClickCallback(datepicker, event);
        rangeUpdate(days);
      });

      day.addEventListener('keydown', (event) => {
        const keyCode = event.keyCode || event.which;

        if (keyCode === 13) {
          dayClickCallback(datepicker, event);
          rangeUpdate(days);
        }
      });
    });

    const saveButton = getSaveButton(datepicker);
    const control = datepicker.closest('.js-control');
    const controlTrigger = control?.querySelector('.js-control-trigger');

    if (saveButton) {
      saveButton.addEventListener('keydown', (event) => {
        if (event.key === 'Tab' && event.shiftKey) {
          event.preventDefault();
          focusDay(datepicker, datepicker.dataset.today);
        }
      });
    }

    controlTrigger?.addEventListener('click', () => {
      if (dateStart && dateEnd) {
        saveButtonShow(datepicker);
      }
    });

    controlTrigger?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        if (dateStart && dateEnd) {
          saveButtonShow(datepicker);
        }
      }
    });

    datepicker.addEventListener('focusout', () => {
      setTimeout(() => {
        const focused = document.activeElement;
        if (!focused || datepicker.contains(focused)) {
          return;
        }

        if (control) {
          controlClose(control);
        }
        saveButtonHide(datepicker);
        const nextTrigger = findNextControlTrigger(control);
        if (nextTrigger) {
          nextTrigger.focus();
        } else {
          controlTrigger?.focus();
        }
      }, 0);
    });
  });
}
